import { createStore, createEvent } from 'effector';

export const NotificationType = {
  Error: 'error',
  Success: 'success',
  Warning: 'warning',
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

interface Notification {
  type: NotificationType;
  message: string | null | undefined;
}

const setErrorEvent = createEvent<string | null | undefined>();
const setSuccessEvent = createEvent<string | null | undefined>();
const setWarningEvent = createEvent<string | null | undefined>();
const clearEvent = createEvent();

const $errorStore = createStore<Notification | null>(null)
  .on(setErrorEvent, (_, message) => (message ? { type: NotificationType.Error, message } : null))
  .on(setSuccessEvent, (_, message) => (message ? { type: NotificationType.Success, message } : null))
  .on(setWarningEvent, (_, message) => (message ? { type: NotificationType.Warning, message } : null))
  .reset(clearEvent);

let timeoutId: NodeJS.Timeout | null = null;
$errorStore.watch((notification) => {
  if (!notification?.message) return;

  if (timeoutId) clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    clearEvent();
    timeoutId = null;
  }, 10000);
});

export const $notificationStore = {
  events: {
    setError: setErrorEvent,
    setSuccess: setSuccessEvent,
    setWarning: setWarningEvent,
    clear: clearEvent,
  },
  store: $errorStore,
};
